/**
 * WWW Application JavaScript
 * 
 * Note: Cart badge updates are handled by primeval.js after globals.json fetch
 */

export default function wwwAppInit() {
  const $ = window.jQuery;
  const $body = $('body');

  // Alert header (live event banners)
  if (window.live_event_banner && !window?.reactProps?.rpState) {
    const navbarAlertElement = document.getElementById('site-navbar-alert') || document.getElementById('site-navbar-sale');
    if (navbarAlertElement) {
      navbarAlertElement.innerHTML = window.live_event_banner;
    }
  }

  // Loading button state handler (used by quote builder)
  $(document).on('click', '.btn-loading', function() {
    const btn = $(this);
    if (btn.html() === btn.data('loading-text')) {
      btn.html(btn.data('text-original'));
    } else {
      setTimeout(function() {
        btn.data('text-original', btn.html());
        btn.html(btn.data('loading-text'));
        btn.prop('disabled', true).addClass('disabled');
      }, 300);
    }
  });

  // Video header autoplay (used by landing pages with background video)
  if ($body.hasClass('page-with-video')) {
    if (window.isMobile === false) {
      window.VID = window.VID || document.getElementById('video-header');
      window.VID?.play?.();
    } else {
      window.VID?.pause?.();
    }
  }
}
